
bq.shippingMethodData = function(element, options) {
    this.options  = options;
    this.$element = $(element);
    this.control  = {ls:false, la:false, rs:false, ra:false};
};

bq.shippingMethodData.DEFAULTS = {
    input: 'input.shipping-method-data',
    left: {},
    right: {},
    escapeMarkup: function(m) { return m; },
};

bq.shippingMethodData.prototype = {
    init: function() {
        bq.debug.log("Shipping Method Data : init()", this.$element);

        this.control.ls = $('#' + this.options.controlLs);
        this.control.la = $('#' + this.options.controlLa);
        this.control.rs = $('#' + this.options.controlRs);
        this.control.ra = $('#' + this.options.controlRa);
        this.left = this.$element.find('select.multiselect').eq(0);
        this.right = this.$element.find('select.multiselect').eq(1);

        this.create();
    },

    create: function() {
        var $options = {
            right: '#' + this.right.attr('id'),
            rightAll: '#' + this.control.ra.attr('id'),
            rightSelected: '#' + this.control.rs.attr('id'),
            leftSelected: '#' + this.control.ls.attr('id'),
            leftAll: '#' + this.control.la.attr('id'),
            afterMoveToRight: this.changeHandler.bind(this),
            afterMoveToLeft: this.changeHandler.bind(this),
            sort: function(a, b) {
                return (a.innerHTML.toLowerCase() > b.innerHTML.toLowerCase()) ? 1 : -1;
            }
        };

        this.left.multiselect($options);
    },

    input: function() {
        if (typeof (this._input) == 'undefined') {
            this._input = this.$element.find(this.options.input);
        }
        return this._input;
    },

    changeHandler: function(left, right, selected) {
        this.invertValuesHandler(right);
    },

    invertValuesHandler: function(elem) {
        var selectedIds = $('#' + elem.attr('id') + ' option').map(function() {return $(this).val();}).get();
        this.input().val(selectedIds)
    },

};

// SHIPPING METHOD DATA PLUGIN DEFINITION
// =======================

var shippingMethodDataOld = $.fn.shippingMethodData;

$.fn.shippingMethodData = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.shippingMethodData');
        var options = $.extend({}, bq.shippingMethodData.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.shippingMethodData', (data = new bq.shippingMethodData(this, options))); }
        data.init();
    });
};

$.fn.shippingMethodData.Constructor = bq.shippingMethodData;

// SHIPPING METHOD DATA NO CONFLICT
// =================

$.fn.shippingMethodData.noConflict = function () {
    $.fn.shippingMethodData = shippingMethodDataOld;
    return this;
};

// SHIPPING METHOD DATA DATA-API
// ==============

bq.shippingMethodDataInit = function() {
    $('[data-bq="shipping-method-data"]').each(function () {
        var el = $(this);
        if(el.data('bq.shippingMethodData')) { return; }
        el.shippingMethodData(el.data());
    });

    $('#is_shipping_method_supported').on('change', function(){
        if (this.value === '1') {
            $('.shipping-method-secondary-row').removeClass('hidden');
        } else {
            $('.shipping-method-secondary-row').addClass('hidden');
        }
    });
};

bq.init.push(bq.shippingMethodDataInit);
